module.exports = __webpack_public_path__ + "img/performax-small.e16f3fc2.svg";